import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link } from 'react-router-dom';

import { Pill } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';
import { useStore } from '@feathr/extender/state';
import { templateTypeIcon, templateTypeTheme } from '@feathr/extender/styles/template';

interface IProps {
  id: string;
  linkToItem?: boolean;
}

function TemplateChip({ id, linkToItem = true }: IProps) {
  const { Templates } = useStore();
  const localUrl = useLocalUrl();

  const template = Templates.get(id);
  if (template.isErrored) {
    return null;
  }

  if (template.isPending) {
    return <Pill isLoading={true} />;
  }

  const cls = template.get('_cls');
  const content = (
    <Pill prefix={<FontAwesomeIcon icon={templateTypeIcon(cls)} />} theme={templateTypeTheme(cls)}>
      {template.name}
    </Pill>
  );

  if (linkToItem) {
    return <Link to={localUrl(template.getItemUrl())}>{content}</Link>;
  }
  return content;
}

export default observer(TemplateChip);
